import { useSnackbar } from 'notistack'
import { useCallback, useState } from 'react'
import { CarePartnersService, CarePartnerUpdateDTO } from '../client'

export const useUpdateCarePartner = () => {
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)
    const { enqueueSnackbar } = useSnackbar()

    const updateCarePartner = useCallback(
        async (carePartnerId: string, carePartnerData: CarePartnerUpdateDTO) => {
            setLoading(true)
            setError(null)
            try {
                const response = await CarePartnersService.updateCarePartnerCarePartnersCarePartnerIdPatch({
                    carePartnerId,
                    requestBody: carePartnerData
                })
                enqueueSnackbar('Care partner updated successfully', { variant: 'success' })
                return response
            } catch (err) {
                const errorMessage = err instanceof Error ? err.message : 'Failed to update care partner'
                setError(errorMessage)
                enqueueSnackbar(errorMessage, { variant: 'error' })
                throw err
            } finally {
                setLoading(false)
            }
        },
        [enqueueSnackbar]
    )

    return { updateCarePartner, loading, error }
}
